var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMykenpoIcon = function SvgMykenpoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 -1 34 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B5E66",
    d: "M33.033 9.138v13.733c0 .282-.079.615-.203.94L16.518 8.001l8.05-7.797c.398.145.786.359 1.032.606l6.605 6.397c.247.24.477.606.627 1 .123.324.202.657.202.939z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A29A",
    d: "M32.83 23.801c-.15.385-.38.76-.626 1l-6.605 6.396c-.256.256-.67.479-1.085.624-.308.11-.635.18-.908.18H9.426c-.291 0-.635-.078-.961-.197l8.016-7.763 8.298-8.037z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B5E66",
    d: "m16.472 24.04-8.016 7.764c-.397-.145-.785-.367-1.032-.607L.82 24.801c-.246-.24-.476-.607-.626-1L8.21 16.04z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A29A",
    d: "m24.577.205-8.052 7.797-8.297 8.037-8.025 7.763c-.124-.325-.203-.658-.203-.94V9.13c0-.265.07-.581.185-.88.15-.41.38-.803.644-1.05L7.434.802C7.68.563 8.06.342 8.466.196 8.8.076 9.136 0 9.426 0h14.18c.292 0 .636.077.97.196z"
  })));
};
export default SvgMykenpoIcon;